module.exports = __webpack_public_path__ + "img/emo_53.1fed9664.png";